import { useCallback, useState } from "react";
import FilterSearchScreenModal from "./FilterSearchScreenModal";

const useFilterSearchScreenModal = () => {
  const [modalProps, setModalProps] = useState(null);

  const closePopup = async () => {
    setModalProps(null);
  };

  const renderModal = useCallback(() => {
    return (
      <>
        {modalProps ? (
          <FilterSearchScreenModal
            isOpen={modalProps}
            onClose={closePopup}
            title={modalProps?.title}
            customIcon={modalProps?.customIcon}
            selectionType={modalProps?.selectionType}
            payloadName={modalProps?.payloadName}
            sectionName={modalProps?.sectionName}
            api={modalProps?.api}
            server_side_search={modalProps?.server_side_search}
            value={modalProps?.value}
            selectedStyle={modalProps?.selectedStyle}
            api_query_key={modalProps?.api_query_key}
            name={modalProps?.name}
            inputLabel={modalProps?.inputLabel}
            sub_options={modalProps?.sub_options}
            brandsData={modalProps?.brandsData}
            brandsLoading={modalProps?.brandsLoading}
            defaultList={modalProps?.defaultList}
          />
        ) : (
          <></>
        )}
      </>
    );
  }, [modalProps]);

  const showModal = useCallback((props: any) => {
    setModalProps(props);
  }, []);

  return { renderModal, showModal };
};

export default useFilterSearchScreenModal;
